import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards4 from "./Cards_4";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }

  /*
  
  <div className="">
            <animated.div
                    class="card2"
                    onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
                    onMouseLeave={() => set({ xys: [0, 0, 1] })}
                    style={{ transform: props.xys.interpolate(trans) , width : "19%" , backgroundImage:  'url("./pictures/images_6.jpg")' }}     
            /> 

        </div>

        <a  href="http://idms-firm-filali.com.s3-website-us-west-2.amazonaws.com/solution"   style = {divStyle} className="">Learn more ...</a> 
  */
  return (
        <div className="">
          

        <div   id = "signal-report"    className="card-2"   style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   > 
        <br></br>
        <a     id ="Strategy" aria-expanded="false" ><img className=""  width="170px" height="70px" src= "./pictures/images_24.jpg"></img><span className="doc-content-title">Risk Management</span></a>
                          <div className="wrapper_line"></div>

                          <br></br>

                <p id="page_summary_id" className="page_summary_id">
                <span>Our platform integrates advanced quantitative risk-management methodologies designed to support real-time monitoring, scenario analysis, and controlled exposure management across dynamic market conditions</span>
                <span>The system evaluates market price risk using futures market data combined with risk-neutral valuation methodologies, mean-reverting stochastic models, seasonal behavior analysis, and jump-diffusion components to better capture abnormal market movements and volatility shocks.</span>
                  <br></br>    

                  
                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                
                </p>

                <br></br>
    
                <Cards4 />
                <br></br>
               


        </div>

        
        </div>

  )
};

export default Card; 


